<template>
  <div class="app-home-container">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">

        <van-list
                    v-model="loading"
                    :finished="finished"
                    :offset="50"
                    :immediate-check="false"
                    :finished-text="$t('video.no_more')" :loading-text="$t('refresh.loading')"
                    @load="onLoad"
                >
                <div class="app-movie-list-n" v-if="movielist_1.length > 0">
            <div class="app-movie-list-n-item" v-for="(v,key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
              <div class="app-movie-list-n-title">
                {{v.name}}
              </div>
              <div class="app-movie-list-n-img">
                <van-image
                  fit="cover"
                  :src="v.img"
                  class="app-movie-list-n-img" :data-src="v.img"  alt=""  v-lazy="v.img"
                />
                <!-- <img> -->
                <div class="app-movie-list-n-lab">{{v.address}}</div>
              </div>
              <div class="app-movie-list-n-item-bottom">
                <div class="app-movie-n-time-div">
                 <img class="app-movie-like-icon" v-for="item in 6" :key="item" src="@/assets/images/pages/discover/ico-love.png"  alt="" >
                  <div class="app-movie-list-notice">
                    <img class="app-movie-list-ico-notice" src="@/assets/images/pages/discover/ico-notice.png"  alt="" >
                    {{ v.comment_total }}
                  </div>
                  <div class="app-movie-list-addr">
                    <img class="app-movie-list-ico-addr" src="@/assets/images/pages/discover/ico-addr.png"  alt="" >
                    {{v.city_name}}
                  </div>
                  <div class="app-movie-list-money">
                    <img class="app-movie-list-ico-money" src="@/assets/images/pages/discover/ico-money.png"  alt="" >{{v.price}}</div>

                </div>
              </div>
            </div>
          </div>
   </van-list>

      </van-pull-refresh>
</div>



</template>

<script>
export default {
  data() {
    return {
      movielist_1:[],
      loading: false,
      finished: false,
      refreshing: false,
      isLoading:false,
      page:1,
      count:0
    };
  },
  methods:{
    gotoMenu(router){
      this.$router.replace(router)
    },
    toPlayVideo(id) {

      if(!localStorage.getItem('token') && this.$store.getters.getBaseInfo.video_login == 1){
        this.$router.push({path:'/auth/login'})
      } else {
        if (id) {
         this.$router.push({path:'/discover/detail?id='+id})
        }
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.page = 1
        // this.movielist_1 = []
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t('reservation.refresh'));
      }, 500);
    },
    onLoad() {
      console.log(222)
        this.loading = true;
        this.getBasicConfig();
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.movielist_1 = [];
          this.refreshing = false;
        }
        // this.loading = false;
        if (this.movielist_1.length === this.count) {
          this.finished = true;
        }
        this.finished && clearTimeout(timer);//清除计时器
      }, 500);
    },
    getBasicConfig(){
      this.$http({
        method: 'get',
        url: 'nHomeList',
        data:{page:this.page},
      }).then(res => {
        console.log(res.data)
        this.loading = false;
        if(this.page == 1){
          this.movielist_1 = res.data;
        }else{

          this.movielist_1 = this.movielist_1.concat(res.data);
        }
        if(res.data.length == 0){
          this.finished = true;
        }else{
          this.finished = false;
        }
        this.count = res.data.count;
        this.page++;
      })

    },

    query(selector) {
     return Array.from(document.querySelectorAll(selector));
    },
    lazyLoadImg() {
      if (this.movielist_1.length > 0) {
      this.query("img[data-src]").forEach((img) => {
          const rect = img.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            img.src = img.dataset.src;
            // 我们是通过img[data-src]查找所有img标签的，渲染后就删除data-src可减少forEach循环的计算成本
            img.removeAttribute("data-src");
          }
        });
      }
    }
  },
  mounted() {
    let that = this;
    window.addEventListener("scroll", () => {
      // 这里做一个 节流 操作
      that.lazyLoadImg()
    });
  },
  created() {
    this.$http({
        method: 'get',
        url: 'base_info'
    }).then(res => {
      if (res.code == 200) {

        if(!localStorage.getItem('token') && res.data.video_login == 1){
         return this.$router.push({path:'/auth/login'})
        }
        this.isLoading = false
        this.$store.commit('setBaseInfoValue', res.data);
    this.getBasicConfig();
        }
      })
  }
}

</script>

<style lang='less' scoped src="./list.styles.less"></style>
